"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MinimizeSVG = void 0;
var _react = _interopRequireDefault(require("react"));
var _logging = require("../../../util/logging");
var _IconCollapse = _interopRequireWildcard(require("./IconCollapse"));
// eslint-disable-next-line zillow/import/no-named-default

var MinimizeSVG = _IconCollapse.CollapseSVG;
exports.MinimizeSVG = MinimizeSVG;
var Minimize = function Minimize(props) {
  (0, _logging.logDeprecation)("`IconMinimize` has been deprecated, use `IconCollapse`");
  return /*#__PURE__*/_react.default.createElement(_IconCollapse.default, props);
};
Minimize.displayName = 'IconMinimize';
var _default = Minimize;
exports.default = _default;